import classNames from 'classnames'

import { type InputEvent } from '@/pages/Dms/helper'

import style from './InputFilter.module.scss'
import Search from './search.svg'

interface IProps {
    value: string | null
    classname?: string
    onChange: (e: InputEvent) => void
    onGetInsuredsList: () => void
    placeholder: string
}

export const InputFilter = (props: IProps) => (
    <div className={classNames(style.container, props.classname)}>
        <input
            className={style.input}
            value={props.value || ''}
            placeholder={props.placeholder}
            onChange={props.onChange}
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    props.onGetInsuredsList()
                }
            }}
        />
        {props.value && (
            <div className={style.searchWrapper} onClick={props.onGetInsuredsList}>
                <Search />
            </div>
        )}
    </div>
)
